import { useMemo } from 'react';

import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { enUS as enUSDatagrid, nlNL as nlNLDatagrid } from '@mui/x-data-grid/locales';
import { enUS as enUSDatePickers, nlNL as nlNLDatePickers } from '@mui/x-date-pickers/locales';
import { useTranslation } from 'react-i18next';

import { ThemeEnum } from '~enums';

import baseTheme from './baseTheme';
import lightTheme from './lightTheme';

// const isSystemThemeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
// const AppTheme = () => {
// 	const { i18n } = useTranslation();

// 	return useMemo(
// 		() =>
// 			createTheme(
// 				lightTheme,
// 				baseTheme,
// 				i18n.resolvedLanguage === 'en' ? enUSDatePickers : nlNLDatePickers,
// 				i18n.resolvedLanguage === 'en' ? enUSDatagrid : nlNLDatagrid,
// 			),
// 		[i18n.resolvedLanguage],
// 	);
// };

// export default AppTheme;

const instantiatedTheme = createTheme(
	deepmerge(baseTheme, lightTheme),
	enUSDatePickers,
	nlNLDatagrid
);

export default instantiatedTheme;
